"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var Table = /** @class */ (function (_super) {
            __extends(Table, _super);
            function Table(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this._keyDown = function (event) {
                    $dyn.util.handleShortcuts(_this, (event));
                };
                _this.StartColumnHeaderResize = function (event, ui) {
                    var newColSize;
                    // because of bug in jquery resize, we need to calculate size
                    // the bug causes originalSize and size to be reversed for RTL, thus we need to do the size math.
                    if ($dyn.util.isRTLMode()) {
                        newColSize = ui.originalSize.width + (ui.originalSize.width - ui.size.width);
                    }
                    else {
                        newColSize = ui.originalSize.width + (ui.size.width - ui.originalSize.width);
                    }
                    _this._processColumnHeaderResize(event, true, newColSize);
                };
                _this.StopColumnHeaderResize = function (event) {
                    $dyn.log.list && $dyn.log("column header resize header function called");
                    _this._processColumnHeaderResize(event, true);
                };
                _this.OnScroll = function () {
                    if (_this.SyncHorizontalScrollOffset) {
                        _this.SyncHorizontalScrollOffset();
                    }
                };
                _this.FocusIn = function (evt) {
                    var elem = evt.target;
                    var control = $dyn.context(elem);
                    // Block atempts to focus while the focus is being changed
                    if (!_this._focusChanging) {
                        _this._focusChanging = true;
                        var focusedCell = _this._getCellFromElement(elem);
                        var newActiveControlName = control && control.Name;
                        var columnIndex = $dyn.value(_this.ColumnIndex);
                        var rowIndex = $dyn.value(_this.RowIndex);
                        if (focusedCell.columnIndex !== columnIndex || focusedCell.rowIndex !== rowIndex) {
                            if (control.TypeName === "RowTemplate_Table") {
                                $dyn.log.list && $dyn.log.list("Table: Select row: old row=%s, new row=%s", rowIndex, focusedCell.rowIndex);
                                var prevSelectedIndex = rowIndex;
                                var newSelectedIndex = focusedCell.rowIndex;
                                _this.UpdateRowSelection(prevSelectedIndex, newSelectedIndex);
                                $dyn.setValue(_this, "ColumnIndex", focusedCell.columnIndex);
                            }
                            else if (control.TypeName !== "Table") {
                                $dyn.log.list && $dyn.log.list("Table: Focus cell: old col=%s, old row=%s, new col=%s, new row=%s, %s", columnIndex, rowIndex, focusedCell.columnIndex, focusedCell.rowIndex, newActiveControlName);
                                // The table control uses the SelectCell command to due "virtual focusing" of the cell.
                                $dyn.callFunction(_this.SelectCell, _this, [newActiveControlName]);
                            }
                        }
                        $dyn.setValue(_this, "ColumnIndex", focusedCell.columnIndex);
                        $dyn.setValue(_this, "RowIndex", focusedCell.rowIndex);
                        // Retargeting the "focus event" to be the table control
                        $dyn.setValue(_this.Root, "ActiveControl", _this.Name);
                        _this._focusChanging = false;
                    }
                    // The table control acts as a "focus boundary" where it absorbs focus events for its focus events subcomponents
                    $dyn.log.list && $dyn.log.list("Table: Stop propagation of focus event handled by table");
                    evt.stopImmediatePropagation();
                };
                _this.OnKeyboardSecondaryNavigation = function (event) {
                    if (!$dyn.value(_this.Enabled)) {
                        event.preventDefault();
                    }
                    else if (_this.IsNavigationAction(event) && $dyn.value(_this.NavigationEnabled)) {
                        var rowElement = $(event.target).closest(".rowTemplate")[0];
                        if (!rowElement) {
                            return;
                        }
                        event.preventDefault();
                        $dyn.getFunction(_this.NavigationAction)();
                    }
                };
                _this.OnMouseSecondaryNavigation = function (event) {
                    function preventDefaultAndStopPropagation() {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Mouse Secondary Navigation (Navigation Action)");
                    }
                    if (!$dyn.value(_this.Enabled)) {
                        preventDefaultAndStopPropagation();
                    }
                    else {
                        var rowElement = $(event.target).closest(".rowTemplate")[0];
                        if (!rowElement) {
                            return;
                        }
                        // ForcePrimaryNavigation = is the grid in a lookup
                        if (!$dyn.value(_this.AllowEdit) && $dyn.value(_this.Enabled) && $dyn.value(_this.NavigationAction) && $dyn.value(_this.ForcePrimaryNavigation)) {
                            // If the target control is editable inside the readonly grid
                            // then we should not stop the propagation and the default action
                            var controlContext = $dyn.context(event.target);
                            if (!controlContext || !$dyn.value(controlContext.AllowEdit)) {
                                preventDefaultAndStopPropagation();
                            }
                            // ForcePrimaryNavigation execute the navigation regardless of where it was clicked
                            $dyn.getFunction(_this.NavigationAction)();
                        }
                        else if (_this.IsNavigationAction(event) && $dyn.value(_this.NavigationEnabled)) {
                            if ($dyn.util.clickedText(event.target)) {
                                // Only preventDefault and navigate if the text is clicked or its a card list. In other cases (such as if the lookup button is clicked) do not navigate.
                                preventDefaultAndStopPropagation();
                                $dyn.getFunction(_this.NavigationAction)();
                            }
                        }
                        else if (!_this.IsValidSecondaryNavigation(event)) {
                            preventDefaultAndStopPropagation();
                        }
                    }
                };
                _this._headerPreRender = function () {
                    var prefixElement = _this._getHeaderPrefix();
                    var parent = prefixElement && prefixElement.parentNode;
                    if (parent) {
                        parent.removeChild(prefixElement);
                    }
                };
                _this._headerPostRender = function () {
                    var prefixElement = _this._getHeaderPrefix();
                    var headerElement = _this._headerRowElement;
                    if (headerElement) {
                        headerElement.insertBefore(prefixElement, headerElement.firstChild);
                    }
                    var colCount = $dyn.length(_this.ColumnHeaderMetadata);
                    _this.element.setAttribute("aria-colcount", colCount.toString());
                };
                _this.postRenderInternal = function () {
                    _this.element.setAttribute("aria-rowcount", _this._rowCount.toString());
                    _this.performHeaderLayout();
                    // Call the public post render callback, if any
                    $dyn.applyFunction(_this.PostRender, _this);
                };
                _this.headerFocusOut = function (event) {
                    var destinatonTargetElement = document.activeElement;
                    if (event && event.relatedTarget) {
                        destinatonTargetElement = event.relatedTarget;
                    }
                    if ($(destinatonTargetElement).closest(".listAsTable-HeaderRow").length <= 0) {
                        _this.AllowHeaderFocus(false);
                        if (_this._headerTabbingContainerDispose) {
                            _this._headerTabbingContainerDispose();
                            _this._headerTabbingContainerDispose = null;
                        }
                    }
                };
                var root = $(element);
                _this.ForEachRenderCount = $dyn.observable(0);
                _this.LayoutMinWidth = { minSizeFunction: $dyn.layout.gridLayoutMinWidth, cssClassArgument: "listRoot" };
                _this.LayoutMinHeight = { minSizeFunction: $dyn.layout.gridLayoutMinHeight, cssClassArgument: "listRoot" };
                _this.ShowHeader = $dyn.computed(function () {
                    return $dyn.value(_this.Mode) === $dyn.ui.ListMode.tabular && $dyn.value(_this.IsHeaderVisible);
                });
                _this.AllowHeaderFocus = $dyn.observable(false);
                _this.SkipColumnHeaders = $dyn.computed(function () {
                    return !$dyn.value(_this.AllowHeaderFocus);
                });
                _this.RenderedHeaderMetadata = $dyn.observable();
                _this._headerRowElement = _this.element && _this.element.querySelector(".listAsTable-HeaderRow");
                _this._noRowsIndicator = _this.element && _this.element.querySelector(".list-No-Rows-Indicator");
                var previousRowIndex = -1;
                var previousColumnIndex = -1;
                var headerMetadata = [];
                _this.ColumnHeaderMetadata = $dyn.computed(function () {
                    var columnLabels = $dyn.value(_this.ColumnLabels);
                    if (columnLabels) {
                        for (var index = 0; index < columnLabels.length; index++) {
                            var label_1 = columnLabels[index];
                            var columnName = "Column" + index;
                            var columnHeader = headerMetadata[index];
                            if (!columnHeader) {
                                headerMetadata[index] = {
                                    Alignment: "Auto",
                                    ControlType: "",
                                    FieldName: "",
                                    FormDataSourceName: _this.DataSourceName,
                                    IsFilterable: $dyn.observable(false),
                                    IsFiltered: $dyn.observable(false),
                                    IsLookupField: false,
                                    IsNumber: false,
                                    IsSortable: $dyn.observable(false),
                                    IsSorted: $dyn.observable(-1),
                                    Label: $dyn.observable(_this.getColumnLabel(label_1, true)),
                                    Name: columnName,
                                    Visible: true,
                                };
                            }
                            else {
                                columnHeader.Label(_this.getColumnLabel(label_1, true));
                            }
                        }
                    }
                    // Delete old headers which don't exist in the new collection
                    var newColumnCount = (columnLabels != null ? columnLabels.length : 0);
                    if (newColumnCount < headerMetadata.length) {
                        headerMetadata.splice(newColumnCount, headerMetadata.length - newColumnCount);
                    }
                    // Queue header layout in case this change is happening outside of the core render (foeach) scenarios. Note that this is
                    // only necessary when the column labels collection is being manually specified as the collection of metadata is independent
                    // from the mechanisms that would normally trigger foreach to run.
                    _this.performHeaderLayout();
                    return headerMetadata;
                });
                if (root[0] && root[0].getAttribute("data-dyn-controlname")) {
                    _this.ListBoxIdentifier = "lb-" + root[0].getAttribute("data-dyn-controlname");
                }
                // Indicates if table has no data, which is the case when either it has no rows OR no columns
                // This is because table can be pivoted either on rows or columns without having any cells
                _this.IsNoResultsMessageDisplayed = $dyn.computed(function () {
                    return $dyn.length(_this.DataSource) === 0 || $dyn.length(_this.ColumnLabels) === 0;
                });
                _this.NoResultImage = $dyn.shell.rootPath.concat("resources/images/emptyGrid.svg");
                _this.usingDisposable($dyn.observe($dyn.options(function () {
                    return { rowIndex: _this.RowIndex, columnIndex: _this.ColumnIndex, children: $dyn._getChildren(element) };
                }, $dyn.ui.updating), function (options) {
                    var previousRow = options.children[previousRowIndex];
                    if (previousRow) {
                        previousRow.setAttribute("data-dyn-row-active", "false");
                        previousRow.setAttribute("data-dyn-row-selecting", "false");
                    }
                    var childElement = options.children[options.rowIndex];
                    if (childElement) {
                        childElement.setAttribute("data-dyn-row-active", "true");
                    }
                    if (!_this._focusChanging && (previousRowIndex !== options.rowIndex || previousColumnIndex !== options.columnIndex)) {
                        $dyn.log.list && $dyn.log.list("Table: Active cell changed: old col=%s, old row=%s, new col=%s, new row=%s", previousColumnIndex, previousRowIndex, options.columnIndex, options.rowIndex);
                        if (_this.Root && $dyn.value(_this.Root.ActiveControl) === _this.Name) {
                            $dyn.log.list && $dyn.log.list("Table: Active cell changed - focusing child");
                            _this.setChildControlFocus();
                        }
                    }
                    previousRowIndex = options.rowIndex;
                    previousColumnIndex = options.columnIndex;
                }));
                if (!$dyn.isObservable(_this.GridLines)) {
                    // GridLines must be an observable value.
                    _this.GridLines = $dyn.observable(_this.GridLines);
                }
                var _headerLayoutTracker = $dyn.observable(0);
                var _headerLayoutScheduled = false;
                _this.scheduleHeaderLayout = function () {
                    if (!_headerLayoutScheduled) {
                        _headerLayoutScheduled = true;
                        _headerLayoutTracker($dyn.value(_headerLayoutTracker) + 1);
                    }
                };
                _this.usingDisposable($dyn.observe($dyn.options({ ColumnLabels: _this.ColumnLabels, Children: _this.Children, HeaderLayout: _headerLayoutTracker }, $dyn.ui.updating), function () {
                    _this.performHeaderLayout();
                    _headerLayoutScheduled = false;
                }));
                var scrollRegion;
                var tableHeader;
                var lasthorizontalOffset;
                // Synchronizes the header's horizontal scroll offset with the data table's horizontal scroll offset.
                _this.SyncHorizontalScrollOffset = function () {
                    if (!scrollRegion) {
                        // Cache the header and scroll region
                        scrollRegion = root.find(".scrollRegion").first();
                        tableHeader = root.find(".table_header").first();
                    }
                    var horizontalOffset = -scrollRegion.scrollLeft();
                    // for RTL we need special math just for webkit offset calculations
                    if ($dyn.util.isRTLMode() && $dyn.util.isWebKit()) {
                        var offset = Math.abs(horizontalOffset);
                        horizontalOffset = -(scrollRegion[0].scrollWidth - scrollRegion[0].clientWidth - offset);
                    }
                    if (lasthorizontalOffset !== horizontalOffset) {
                        // Only sync if changed set left for non RTL , right for RTL
                        if (!$dyn.util.isRTLMode()) {
                            tableHeader.css("margin-left", horizontalOffset.toString() + "px");
                        }
                        else {
                            tableHeader.css("margin-right", horizontalOffset.toString() + "px");
                        }
                        $dyn.log.list && $dyn.log.list("List: Sync offset from %s to %s", lasthorizontalOffset, horizontalOffset);
                    }
                    lasthorizontalOffset = horizontalOffset;
                };
                return _this;
            }
            Table.prototype._rowMutator = function (element, index) {
                if (element.getAttribute("data-dyn-role") === "RowTemplate") {
                    element.setAttribute("data-dyn-role", "RowTemplate_Table");
                    element.setAttribute("data-dyn-role-orig", "RowTemplate");
                }
                element.setAttribute("aria-rowindex", (index + 1).toString());
            };
            Table.prototype._columnMutator = function (element, index) {
                element.classList.add("listCell");
                // Used data attribute "data-colindex" instead of aria-colindex, since screen readers incorrectly read aria-columnindex with some browsers.
                // Accessible aria-columnindex value will be generated automatically by browser.
                element.setAttribute("data-colindex", (index + 1).toString());
            };
            Table.prototype._getValues = function () {
                // Internal use only
                var rows = $(".listBody", this.element).find(".listItem");
                var rowsArray = [];
                rows.each(function (index, element) {
                    var row = $(element);
                    var rowArray = [];
                    row.find(".listCell:not(.repeater-template)").each(function (listCellIndex, listCell) {
                        var value = "";
                        if ($(listCell).is(".checkBox-container")) {
                            value = $(listCell).attr("aria-checked") ? true : false;
                        }
                        else {
                            var foundInputs = $(listCell).find("input");
                            if (foundInputs.length > 0) {
                                // Simple taking the first input element won't cover all cases, but it is acceptable
                                // given the purposes of this method.
                                var inputElement = foundInputs[0];
                                value = inputElement.value;
                            }
                        }
                        rowArray.push(value);
                    });
                    rowsArray.push(rowArray);
                });
                return rowsArray;
            };
            Table.prototype._changeRow = function (newRowIndex) {
                if (newRowIndex >= 0 && newRowIndex < this._rowCount) {
                    $dyn.setValue(this, "RowIndex", newRowIndex);
                    var cell = $dyn.context(this.getElementAt($dyn.value(this.ColumnIndex), newRowIndex));
                    var cellName = cell && cell.Name;
                    $dyn.callFunction(this.SelectCell, this, [cellName]);
                    return true;
                }
                return false;
            };
            Table.prototype._processColumnHeaderResize = function (event, updatePersonalizationSettings, columnHeaderWidth) {
                var target = $(event.target);
                // Find the column header
                // We might be a content inside column header, so find the closest match
                var closestWrapper = target.closest(".columnHeaderWrapper");
                if (closestWrapper.length) {
                    var columnIndex = closestWrapper.attr("data-colindex");
                    var rowIndex = parseInt(columnIndex, 10);
                    // If it is a control based column, resize it. First column in the set is row label column which is not resized
                    if (rowIndex > 0) {
                        closestWrapper.outerWidth(columnHeaderWidth);
                        // Get the actual width of header after desired width is applied and then apply that width to control columns.
                        // Sometimes header can not achieve the desired width because of minimum width of the elements inside the header.
                        var actualHeaderColumnWidth = $(closestWrapper).width();
                        this._resizeControlColumn(rowIndex - 1, actualHeaderColumnWidth);
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Table column header handling resize event");
                        event.stopPropagation && event.stopPropagation();
                    }
                }
            };
            Table.prototype._resizeControlColumn = function (controlIndex, width) {
                var e_1, _a;
                // Resizes a control based column inside the grid
                // Map to the appropriate contained control and set its width so that the update happens synchronously.
                // Setting the width property on the child control should cause all instances throughout the foreach to be updated.
                var childControlContexts = this.getDataColumnContextsByIndex(controlIndex);
                try {
                    for (var childControlContexts_1 = __values(childControlContexts), childControlContexts_1_1 = childControlContexts_1.next(); !childControlContexts_1_1.done; childControlContexts_1_1 = childControlContexts_1.next()) {
                        var childControlContext = childControlContexts_1_1.value;
                        if (childControlContext && childControlContext.LayoutWidth) {
                            childControlContext.LayoutWidth = width;
                        }
                        /* TODO: Improve performance of persist personalization command (only send the last change to server)
                        if (updatePersonalizationSettings && childControl) {
                            // Persist personalization settings on the server.
                            $dyn.callFunction(childControl.PersistPersonalization, childControl, ["width", width]);
                        }*/
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (childControlContexts_1_1 && !childControlContexts_1_1.done && (_a = childControlContexts_1.return)) _a.call(childControlContexts_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            };
            Table.prototype.calculateMarkMode = function () {
                return;
            };
            Table.prototype.setChildControlFocus = function () {
                // When the table control gets focus it will focus its selected cell.
                var cellElement = this.getElementAt($dyn.value(this.ColumnIndex), $dyn.value(this.RowIndex));
                if (cellElement) {
                    var cellContext = $dyn.context(cellElement);
                    this._focusChanging = true;
                    var focusCallback = cellContext ? cellContext.focusCallback : $dyn.util.focusElement(cellElement, cellContext.Name);
                    if (focusCallback) {
                        focusCallback.call(cellContext, []);
                    }
                    this._focusChanging = false;
                }
            };
            Table.prototype.focusCallback = function () {
                this.setChildControlFocus();
            };
            Table.prototype.SelectCell = function () { };
            Table.prototype._getHeaderId = function (headerData) {
                return headerData && $dyn.value(headerData.Name);
            };
            Table.prototype._getHeaderVersion = function (headerData) {
                return headerData && headerData.Version;
            };
            Table.prototype.findFieldByName = function (fieldName) {
                return $.find(".listBody [data-dyn-controlname='" + fieldName + "']");
            };
            Table.prototype.dispose = function () {
                $dyn.ui.Control.prototype.dispose.call(this);
                this._headerTabbingContainerDispose && this._headerTabbingContainerDispose();
            };
            Table.prototype.performHeaderLayout = function () {
                var root = $(this.element);
                if ($dyn.value(this.ShowHeader)) {
                    (root.find(".table_header")).layoutFloatingTableHeader(root.find(".TabularView"));
                    this.incrementRenderCountOnHeaderLayout = false;
                }
            };
            Table.prototype.rowIndex = function (element) {
                if (!element) {
                    return undefined;
                }
                var clientCacheIndex = parseInt(element.getAttribute("aria-rowindex"), 10) - 1;
                return clientCacheIndex;
            };
            Table.prototype.getColumnLabel = function (label, showLabel) {
                // Can be overriden to get a custom label.
                if ((showLabel === undefined) || $dyn.value(showLabel)) {
                    return label;
                }
                return "";
            };
            Table.prototype.getDataColumnContextsByIndex = function (index) {
                var foundColumns = [];
                var rowTemplates = $dyn.children(this.element);
                if (rowTemplates.length) {
                    jQuery.each(rowTemplates, function (rowTemplateIndex, rowTemplate) {
                        var rowColumns = $dyn.children(rowTemplate);
                        var foundColumn;
                        if (rowColumns) {
                            foundColumn = rowColumns[index];
                        }
                        if (foundColumn) {
                            foundColumns.push($dyn.context(foundColumn));
                        }
                    });
                }
                return foundColumns;
            };
            Table.prototype.GetScrollRegion = function () {
                if (!this.scrollRegion) {
                    this.scrollRegion = $(this.element).find(".scrollRegion").first();
                }
                return this.scrollRegion;
            };
            Table.prototype.getRowElement = function (rowIndex) {
                return $dyn.children(this.element)[rowIndex];
            };
            Object.defineProperty(Table.prototype, "_rowCount", {
                get: function () {
                    return $dyn.children(this.element).length;
                },
                enumerable: false,
                configurable: true
            });
            Table.prototype.SetScrollRegionHeight = function (value) {
                this.GetScrollRegion().height(value);
                this.UpdateScrollRegionHeight();
            };
            Table.prototype.UpdateScrollRegionHeight = function () {
                this.CachedScrollRegionHeight = this.GetScrollRegion().height();
            };
            /**
             * Gets the column and row index given an element
             * @param element the element used to get the cell
             * @returns the column index and row index of the cell
             */
            Table.prototype._getCellFromElement = function (element) {
                var columnIndex = -1;
                var rowIndex = -1;
                var rowElement = $(element).closest(".listItem")[0];
                if (rowElement) {
                    if (rowElement.classList.contains("listAsTable-HeaderRow")) {
                        rowIndex = $dyn.value(this.RowIndex);
                        columnIndex = parseInt(element.getAttribute("data-colindex"), 10);
                        columnIndex = columnIndex > 0 ? columnIndex - 1 : -1;
                    }
                    else {
                        rowIndex = parseInt(rowElement.getAttribute("aria-rowindex"), 10);
                        rowIndex = rowIndex > 0 ? rowIndex - 1 : -1;
                        var cellElement = $(element).closest(".listCell")[0];
                        if (cellElement) {
                            columnIndex = parseInt(cellElement.getAttribute("data-colindex"), 10);
                            columnIndex = columnIndex > 0 ? columnIndex - 1 : -1;
                        }
                    }
                }
                return { columnIndex: columnIndex, rowIndex: rowIndex };
            };
            /**
             * Gets the cell element given the column and row index.
             * @param columnIndex the column index
             * @param rowIndex the row index
             * @returns the element at the giving column and row index
             */
            Table.prototype.getElementAt = function (columnIndex, rowIndex) {
                var rows = $dyn.children(this.element);
                var rowElement = rows[rowIndex];
                if (rowElement) {
                    var columns = $dyn.children(rowElement);
                    return columns[columnIndex];
                }
            };
            /**
             * Updates the visualization of the row at the passed in rowIndex to indicate that it is the selected record before the server returns.
             * The selection visualization on the old record is updated as well.
             * @param oldIndex the old row index
             * @param newIndex the new row index
             */
            Table.prototype.UpdateRowSelection = function (oldIndex, newIndex) {
                if (oldIndex !== newIndex) {
                    if (this._selectingElement) {
                        this._selectingElement.removeAttribute("data-dyn-row-selecting");
                        this._selectingElement = null;
                    }
                    // Remove the data-dyn-row-active attribute off the previous row
                    var rowElement = this.FindRowAtIndex(oldIndex);
                    if (rowElement) {
                        rowElement.setAttribute("data-dyn-row-active", "false");
                    }
                    // Set the aria-selected attribute on the new row.
                    rowElement = this.FindRowAtIndex(newIndex);
                    if (rowElement) {
                        $dyn.log.list && $dyn.log.list("List: Selecting index " + newIndex);
                        if (this.InputMode === $dyn.ui.InputType.mouse) {
                            rowElement.setAttribute("data-dyn-row-active", "true");
                        }
                        else {
                            this._selectingElement = rowElement;
                            rowElement.setAttribute("data-dyn-row-selecting", "true");
                        }
                    }
                }
            };
            Table.prototype.IsNavigationAction = function (event) {
                return $dyn.value(this.NavigationEnabled) && this.TargetSupportsNavigation(event);
            };
            Table.prototype.TargetSupportsNavigation = function (event) {
                var listCell = $(event.target).closest(".listCell");
                return listCell && listCell.hasClass("supportsNavigation");
            };
            /**
             * Determines whether or not the secondary naviation action is valid
             * @param event Represents the secondary naviation action
             * @returns true if the secondary naviation action is allowed, otherwise, false
             */
            Table.prototype.IsValidSecondaryNavigation = function (event) {
                var closestListItem = $(event.target).closest(".listItem");
                return closestListItem.length === 1;
            };
            Table.prototype.FindRowAtIndex = function (pageIndex) {
                return $(this.element).find(".listItem[aria-rowindex=" + (pageIndex + 1) + "]")[0];
            };
            Table.prototype._getHeaderPrefix = function () {
                if (!this._headerPrefix) {
                    this._headerPrefix = $dyn._getTemplate(this._headerPrefixTemplate).cloneNode(true);
                    this._headerPrefix.removeAttribute("id");
                    $dyn.dataBind(this._headerPrefix, this.element.dynContext);
                }
                return this._headerPrefix;
            };
            Table.prototype.SelectCellByName = function (cellName) {
                $dyn.callFunction(this.SelectCell, this, cellName);
            };
            return Table;
        }($dyn.ui.Control));
        controls.Table = Table;
        Table.prototype.isContainer = true;
        Table.prototype.RowLabelColumn = "_RowLabel_";
        Table.prototype._headerPrefixTemplate = "TableRowLabelsHeader";
        Table.prototype.RowIndex = -1;
        Table.prototype.ColumnIndex = -1;
        Table.prototype.ColumnLabels = null;
        Table.prototype.IsHeaderVisible = true;
        //  DataSource is an array of object (not necessarily an array of $dyn.serverForm.Model
        Table.prototype.DataSource = null;
        Table.prototype.NavigationEnabled = false;
        // ForcePrimaryNavigation means that the grid should perform its NavigationAction on row selection.
        Table.prototype.ForcePrimaryNavigation = false;
        Table.prototype.NavigationAction = null;
        Table.prototype.ShowHeader = true;
        // SelectedIndex is copied from the FormDataSource in html-binding-serverform.js
        Table.prototype.SelectedIndex = -1;
        Table.prototype.ExportAllowed = true;
        Table.prototype.ExportLabel = "";
        Table.prototype.ExportToExcel = null;
        // Array valued
        Table.prototype.RowHeightInPixels = 33;
        Table.prototype.VisibleRowCount = 0;
        Table.prototype.VisibleColumnCount = 0;
        Table.prototype.Mode = $dyn.ui.ListMode.tabular;
        Table.prototype.ShowRowLabels = false;
        Table.prototype.GridLines = $dyn.ui.GridLines.Auto;
        Table.prototype.OriginatingType = "";
        // Keyboard or mouse
        Table.prototype.InputMode = null;
        // tslint:disable:object-literal-sort-keys
        var tableShortcuts = {
            AltShiftH: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterH },
                Handler: function (event) {
                    if ($dyn.value(this.ShowHeader)) {
                        if ($(event.target).parents().is(".listHeader")) {
                            this.AllowHeaderFocus(false);
                            if ($dyn.value(this.IsNoResultsMessageDisplayed)) {
                                this._noRowsIndicator && this._noRowsIndicator.focus();
                            }
                            else {
                                this.setChildControlFocus();
                            }
                        }
                        else {
                            var currentColumn = $dyn.value(this.ColumnIndex);
                            var headerColumn = void 0;
                            if (currentColumn >= 0) {
                                headerColumn = $.find("[data-colindex=" + (currentColumn + 1) + "]");
                            }
                            if (!headerColumn || headerColumn.length <= 0) {
                                headerColumn = $.find(".columnHeaderWrapper:not(.markingColumnHeader,.rowLabelHeaderWrapper)");
                            }
                            if (headerColumn && headerColumn.length) {
                                this.AllowHeaderFocus(true);
                                this._headerTabbingContainerDispose = $dyn.util.tabbingContainer(this._headerRowElement, $dyn.label("ListHeader_RegionTitle"));
                                $dyn.log.focus && $dyn.log.focus("Focusing header: " + currentColumn);
                                headerColumn[0].focus();
                            }
                        }
                        return true;
                    }
                    return false;
                },
                ShowToUser: function () { return $dyn.value(this.ShowHeader); },
                Description: function () { return $dyn.value(this.AllowHeaderFocus) ? $dyn.label("Grid_FocusActiveRowShortcut") : $dyn.label("Grid_FocusColumnHeaderShortCut"); },
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
            DownArrow: {
                Keys: { keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    if (!$dyn.value(this.AllowHeaderFocus)) {
                        return this._changeRow($dyn.value(this.RowIndex) + 1);
                    }
                    return false;
                },
                ShowToUser: function () { return !$dyn.value(this.AllowHeaderFocus); },
                Description: $dyn.label("Grid_NextRowShortcut")
            },
            LeftArrowResize: {
                Keys: { keyCode: $dyn.ui.KeyCodes.leftArrow },
                Handler: function (evt) {
                    if (this && evt.target && this.AllowHeaderFocus && evt.target.classList.contains("columnHeaderWrapper")) {
                        var table = $(evt.target).parents("[data-dyn-role='Table']");
                        if (table.length > 0) {
                            var tableContext = $dyn.context(table[0]);
                            if (tableContext) {
                                var newColSize = void 0;
                                // because of bug in jquery resize, we need to calculate size
                                // the bug causes originalSize and size to be reversed for RTL, thus we need to do the size math.
                                if ($dyn.util.isRTLMode()) {
                                    newColSize = evt.target.clientWidth + 1;
                                }
                                else {
                                    newColSize = evt.target.clientWidth - 1;
                                }
                                tableContext._processColumnHeaderResize(evt, true, newColSize);
                                return true;
                            }
                        }
                    }
                    return false;
                },
                ShowToUser: function () { return $dyn.value(this.AllowHeaderFocus); },
                Description: function () {
                    var label = $dyn.label("Grid_ShrinkColumn");
                    if ($dyn.util.isRTLMode()) {
                        label = $dyn.label("Grid_GrowColumn");
                    }
                    return label;
                }
            },
            RightArrowResize: {
                Keys: { keyCode: $dyn.ui.KeyCodes.rightArrow },
                Handler: function (evt) {
                    if (this && evt.target && this.AllowHeaderFocus && evt.target.classList.contains("columnHeaderWrapper")) {
                        var table = $(evt.target).parents("[data-dyn-role='Table']");
                        if (table.length > 0) {
                            var tableContext = $dyn.context(table[0]);
                            if (tableContext) {
                                var newColSize = void 0;
                                // because of bug in jquery resize, we need to calculate size
                                // the bug causes originalSize and size to be reversed for RTL, thus we need to do the size math.
                                if ($dyn.util.isRTLMode()) {
                                    newColSize = evt.target.clientWidth - 1;
                                }
                                else {
                                    newColSize = evt.target.clientWidth + 1;
                                }
                                tableContext._processColumnHeaderResize(evt, true, newColSize);
                                return true;
                            }
                        }
                    }
                    return false;
                },
                ShowToUser: function () { return $dyn.value(this.AllowHeaderFocus); },
                Description: function () {
                    var label = $dyn.label("Grid_GrowColumn");
                    if ($dyn.util.isRTLMode()) {
                        label = $dyn.label("Grid_ShrinkColumn");
                    }
                    return label;
                }
            },
            UpArrow: {
                Keys: { keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function () {
                    if (!$dyn.value(this.AllowHeaderFocus)) {
                        return this._changeRow($dyn.value(this.RowIndex) - 1);
                    }
                    return false;
                },
                ShowToUser: function () { return !$dyn.value(this.AllowHeaderFocus); },
                Description: $dyn.label("Grid_PreviousRowShortcut")
            },
        };
        Table.prototype.Shortcuts = $dyn.extendPrototype($dyn.ui.Control.prototype.Shortcuts, tableShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Table.js.map
